import React from "react";
import PropTypes from "prop-types";
import BaseCovarageDesktop from "./BaseCovarageDesktop";

function PositivacaoCategory({ app, config }) {
  return <BaseCovarageDesktop app={app} config={config} />;
}

PositivacaoCategory.defaultProps = {
  app: null,
  config: {},
};

PositivacaoCategory.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default PositivacaoCategory;
